function titleCaseURL(str) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 1; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
    }
    return splitStr.join(' ').replace(/\s/g, ''); 
}

export default titleCaseURL